import React, { useState, useEffect } from 'react'
import { detect } from 'detect-browser'
import styled from 'styled-components'
import moment from 'moment'
import Paging from '../pagination/Paging'

// components
import DropDown from '../../components/dropdown/DropDown'
import MoDetailItem from './MoDetailItem'
import Empty from '../../pages/reviewList/components/Empty'

// images
import IconDown from '../../assets/image/arrow/ic-down.svg'
import IconUp from '../../assets/image/arrow/ic-up.svg'

// utils
import { useAxios } from '../../utils/useAxios'
import { getComma } from '../../utils/getComma'
import { getOrderDetail } from '../../utils/getOrderDetail'

// globals
import * as constants from '../../globals/constants'
import * as TYPE from '../../globals/type'

// 모바일 주문현황
const MoOrderDetail = ({ orderMode, send, setData, agentPOSData }) => {
  const user = JSON.parse(localStorage.getItem('user'))
  const browser = detect()
  const { fetchData, loading, data, error } = useAxios()
  const [openDetail, setOpenDetail] = useState(false)
  const [orderData, setOrderData] = useState([])
  const [pageCount, setPageCount] = useState(0) // 페이지 next 체크

  // 페이지네이션
  const [count, setCount] = useState(0) //아이템 총 개수
  const [currentpage, setCurrentpage] = useState(1) // 현재페이지
  const [currentsize, setCurrentsize] = useState(10) //페이지당 아이템 개수 (5)
  const sizeOption = ['10', '30', '50', '100']

  const nextPage = (page) => {
    setCurrentpage(page)
  }

  // 아코디언 요소
  const [expandedItems, setExpandedItems] = useState([]) //개별
  const [allExpanded, setAllExpanded] = useState(false) //모든

  // 개인정보 숨겨야 하는 주문(접수번호)
  const [hiddenOrder, setHiddenOrder] = useState([])

  // 모두 펼쳐보기(상세)
  const toggleExpandAll = () => {
    if (allExpanded) {
      setExpandedItems([])
    } else {
      // 모든 아이템 열기
      const itemsToExpand = orderData.map((item) => item.orderNum)
      setExpandedItems(itemsToExpand)
    }
    setAllExpanded(!allExpanded)
  }

  useEffect(() => {
    if (agentPOSData) {
      setOrderData(agentPOSData.responseData?.orderList)
      setData(agentPOSData)
      setCount(agentPOSData.responseData?.itemCount)
    }
  }, [agentPOSData])

  const getItems = async (size, page, send, orderMode) => {
    const params = {
      size: size,
      page: page,
      orderType: send?.orderType,
      detailType: send?.orderDetail,
      orderStatus: send?.orderState === '308' ? undefined : send?.orderState,
      selfDelivery: send?.orderState === '308' ? 'Y' : undefined,
      deliveryStatus: send?.orderDelivery,
      orderNum: send?.orderNum,
      orderMode: orderMode,
      startDate: send?.startDate,
      endDate: send?.endDate,
      ...(orderMode === 'TODAY' && {
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
      }),
    }

    fetchData(
      constants.API.ORDERS_LIST,
      'GET', // method
      null, // body
      params, // params
    )
  }

  // 주소 정보 열람 히스토리 추가
  const setOrderHistoryItem = (order) => {
    const body = {
      appId: TYPE.ID.WEB, // 아이디(에이전트, 사장님웹 구분 값)
      osName: browser.os ?? '', // 운영체제
      pageName:
        orderMode === 'today' // 페이지명
          ? 'todayOrderListPage.TodayOrderList'
          : 'selectOrderListPage.SelectOrderList',
      typeCode: TYPE.ACTION.READ, // 열람
      orderId: order.orderNum, // 주문번호
      orderMessage: `로그인아이디[${user?.userId}]가 오더번호[${order.orderNum}]의 상세주소 열람`, // 저장 메시지
      receiptId: order.ReceiptId,
    }

    // 버튼 클릭하면 해당 접수번호 추가
    setHiddenOrder([...hiddenOrder, order.ReceiptId])

    fetchData(constants.API.WORK_HISTORY_ORDER, 'POST', body)
  }

  const initState = () => {
    setData()
    setCount(0)
    setOrderData([])
  }

  useEffect(() => {
    let resCode = data?.responseCode
    let resData = data?.responseData

    switch (resCode) {
      // 성공(데이터 O)
      case TYPE.API_RESPONSE.SUCCESS:
        if (resData) {
          // 로그
          if (resData.hasOwnProperty('selfDelivery')) {
            if (resData?.isMasking === 'N') {
              setHiddenOrder((prevExpanded) => {
                if (prevExpanded.includes(Number(resData.id))) {
                  return prevExpanded.filter((id) => id !== Number(resData.id))
                }
              })
            }
          }
          // 목록
          else {
            // 요약
            setData(resData)
            // 페이지네이션
            setCount(resData.itemCount)
            // 목록
            setOrderData(resData.orderList)
          }
          break
        }
      // 성공(데이터X)
      case TYPE.API_RESPONSE.NOT_DATA:
        initState()
        break

      // 실패
      case TYPE.API_RESPONSE.FAILURE:
      default:
        break
    }
  }, [data])

  useEffect(() => {
    if (pageCount > 0) {
      getItems(currentsize, currentpage, send, orderMode)
      setExpandedItems([]) // 목록 아코디언 모두 닫은 상태에서 페이지 전환
    }
  }, [currentpage, orderMode])

  // [조회 버튼, 목록수 변경 데이터 호출]
  useEffect(() => {
    setCurrentpage(1) // 페이지가 1인 상태에서 다시 목록이 업데이트 될 수 있게 설정
    getItems(currentsize, 1, send, orderMode)
  }, [send, currentsize])

  return (
    <MoOrderDetailWrap>
      {data?.responseCode === TYPE.API_RESPONSE.NOT_DATA ||
      !data?.responseData ? (
        <EmptyWrap>
          <Empty pointTxt={'조회된 주문현황'} txt={'이 없습니다.'} />
        </EmptyWrap>
      ) : (
        <>
          <BtwBox>
            <AllOpenBtn type="button" onClick={toggleExpandAll}>
              모두 펼쳐보기
              <img src={IconDown} alt="아래화살표" />
            </AllOpenBtn>
            <DropDownWidth>
              <DropDown
                title={currentsize}
                options={sizeOption}
                setOption={setCurrentsize}
                value={currentsize}
                isPageUnit={true}
              />
            </DropDownWidth>
          </BtwBox>
          {orderData?.map((item, i) => {
            const isExpanded = expandedItems.includes(item.orderNum)
            const itemNumber = (currentpage - 1) * currentsize + i + 1
            return (
              <div key={i}>
                <dl>
                  <div className="detailBtwBox">
                    <dt>번호</dt>
                    <dd>{itemNumber ?? ''}</dd>
                  </div>
                  <div className="detailBtwBox">
                    <dt>주문번호</dt>
                    <dd>{item?.orderNum ?? ''}</dd>
                  </div>
                  <div className="detailBtwBox">
                    <dt>주문시간</dt>
                    <dd>
                      {moment(item?.RegDT ?? '', 'YYYYMMDDHHmmss').format(
                        'YYYY-MM-DD (ddd) A h:mm:ss',
                      )}
                    </dd>
                  </div>
                  <div className="detailBtwBox">
                    <dt>주문유형</dt>
                    <dd>{item?.orderType ?? '' === 'D' ? '배달' : '픽업'}</dd>
                  </div>
                  <div className="detailBtwBox">
                    <dt>상세유형</dt>
                    <dd>{getOrderDetail(item?.orderDetail)}</dd>
                  </div>
                  <div className="detailBtwBox">
                    <dt>주문내역</dt>
                    <dd>{item?.goodsName ?? ''}</dd>
                  </div>
                  <div className="detailBtwBox">
                    <dt>주문상태</dt>
                    <dd>{item?.orderStatusName ?? ''}</dd>
                    {/* <dd>{item.orderStatusName}</dd> */}
                  </div>
                  <div className="detailBtwBox">
                    <dt>배달상태</dt>
                    <dd>
                      {item.orderType === 'P'
                        ? item?.deliveryStatusName !== '픽업완료'
                          ? '-'
                          : '픽업완료'
                        : item?.orderStatusName !== '주문접수'
                        ? item?.deliveryStatusName
                        : '주문접수'}
                      {/* {item.orderType === 'P'
                        ? item.deliveryStatusName !== '픽업완료'
                          ? '-'
                          : '픽업완료'
                        : item.deliveryStatusName ?? '-'} */}
                    </dd>
                    {/* <dd>{item.deliveryStatusName}</dd> */}
                  </div>
                  <div className="detailBtwBox">
                    <dt>결제금액</dt>
                    <dd>{getComma(item?.payMoney)}원</dd>
                  </div>
                </dl>
                {isExpanded && (
                  <MoDetailItem
                    orderList={item}
                    hiddenOrder={hiddenOrder}
                    isComplete={item?.orderCompleteYn === 'Y'}
                    isPickup={item?.orderType === 'P'}
                    setOrderHistoryItem={setOrderHistoryItem}
                  />
                )}
                <MoDetailBtn
                  type="button"
                  onClick={() => {
                    setExpandedItems((prevExpanded) => {
                      if (prevExpanded.includes(item?.orderNum)) {
                        return prevExpanded.filter(
                          (id) => id !== item?.orderNum,
                        )
                      } else {
                        return [...prevExpanded, item.orderNum]
                      }
                    })
                  }}
                >
                  {isExpanded ? (
                    <span className="detailOnoff">
                      닫기 <img src={IconUp} alt="" />
                    </span>
                  ) : (
                    <span className="detailOnoff">
                      자세히보기 <img src={IconDown} alt="" />
                    </span>
                  )}
                </MoDetailBtn>
              </div>
            )
          })}
          <Paging
            isTemp={false}
            page={currentpage}
            count={count}
            setPage={(e) => {
              nextPage(e)
              setPageCount(pageCount + 1)
            }}
            marginTop={[40, 40]}
            tableSize={currentsize}
          />
        </>
      )}
    </MoOrderDetailWrap>
  )
}

export default MoOrderDetail

const MoOrderDetailWrap = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  dl {
    padding: 20px;
    border-bottom: 1px solid #f3f3f3;
  }
  .detailBtwBox {
    display: flex;
    width: 100%;
  }
  dt {
    width: 58px;
    font-size: 14px;
    color: #8a8a8a;
    margin-bottom: 18px;
  }
  dd {
    font-size: 14px;
    color: #000;
    margin-left: 10px;
  }
`

const MoDetailBtn = styled.button`
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
  padding: 20px 0 16px;
  border-bottom: 5px solid #e5e5e5;
  img {
    margin-left: 5px;
  }
  .detailOnoff {
    font-size: 14px;
    font-weight: bold;
    color: #000;
  }
`
const BtwBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 8px 20px 28px;
  border-bottom: 1px solid #e5e5e5;
  /* @media ${(props) => props.theme.mobile} {
    padding: 0 20px;
  } */
`
const DropDownWidth = styled.div`
  width: 162px;
`

const AllOpenBtn = styled.button`
  width: 114px;
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: #000;
  padding: 0;
  img {
    margin-left: 5px;
  }
`
const EmptyWrap = styled.div`
  padding: 0px 20px 0px;
`
